import { Grid } from "@material-ui/core";
import { StatusCell } from "../purchaseOrder/PurchaseOrderStatusView";
import { UpgradeStatus, CreditClassEnum } from "../../generated/graphql";

export default ({ upgrade }) => {
    let statusInt = 0;
    let rejectInt = 0;

    const isUpgradeToAorS =
        upgrade?.targetCreditClass === CreditClassEnum.A ||
        upgrade?.targetCreditClass === CreditClassEnum.S;

    // 計算 statusInt 根據實際完成進度
    if (upgrade.gm != null) {
        statusInt = isUpgradeToAorS && upgrade.coo != null ? 4 : 3;
    } else if (upgrade.secretary != null) {
        statusInt = 2;
    } else if (upgrade.ae != null) {
        statusInt = 1;
    }

    // 若有 COO，則再往上加
    if (isUpgradeToAorS && upgrade.coo != null) {
        statusInt = 4;
    }

    if (upgrade.status === UpgradeStatus.Success) {
        statusInt = 5;
    }

    // 若是已被退件，記錄被退回的階段
    if (upgrade.status === UpgradeStatus.Rejected) {
        rejectInt = statusInt;
        statusInt -= 1;
    }

    return (
        <Grid container style={{ marginTop: 20 }}>
            <StatusCell name={upgrade.ae?.name} state={"送出申請"} isFinished={statusInt > 0} />
            <StatusCell name={upgrade.secretary?.name} state={"執行秘書審核"} isFinished={statusInt > 1} />
            <StatusCell name={upgrade.gm?.name} state={"總經理審核"} isFinished={statusInt > 2} isRejected={rejectInt === 3} />
            {isUpgradeToAorS && (
                <StatusCell name={upgrade.coo?.name} state={"營運長審核"} isFinished={statusInt > 3} isRejected={rejectInt === 4} />
            )}
            <StatusCell
                name={upgrade.finance?.name}
                state={"財務審核"}
                isFinished={isUpgradeToAorS ? statusInt > 4 : statusInt > 3}
            />
        </Grid>
    );
};
